import { themeObject } from '../../../../lib';

export const SYSTEM_MESSAGES_CARD = {
    TITLE: 'System Alerts',
    ACTION: 'VIEW ALL',
    DESCRIPTION:
        'There are no new messages in the last 15 days. Visit the System Messages page to view past messages.',
};

export const DEFAULT_DAYS_TO_RETURN = 15;

export const systemMessageCardStyles = {
    cardContainer: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
    },
    messageTitleContainer: {
        display: 'inline-flex',
        alignItems: 'flex-start',
        width: '100%',
    },
    loadingContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '120px',
    },
    cardHeaderText: {
        pl: 0.5,
        fontFamily: 'Raleway',
        fontWeight: '600',
        fontSize: ' 18px',
        lineHeight: '21.13px',
        color: themeObject.palette.grayScale[800],
        fontVariantNumeric: 'lining-nums',
    },
    messageBodyContainer: {
        width: '100%',
        pt: 1,
        'span > span': {
            fontFamily: 'Red Hat Text',
            fontWeight: '400',
            fontSize: '16px',
            lineHeight: '21.17px',
            color: themeObject.palette.grayScale[800],
        },
    },
    messageDateContainer: {
        display: 'flex',
        width: '100%',
        pt: 1,
    },
    postedText: {
        fontFamily: 'Red Hat Text',
        fontWeight: '400',
        fontSize: '12px',
        lineHeight: '15.88px',
        letter: '0.4px',
        color: themeObject.palette.grayScale[800],
    },
};
